<template>
  <div class="map-wrapper" :class="userDevice">
    <div class="map-container">
      <template v-if="userDevice !== 'mobile'">
        <map-header-template />
        <div class="second-row">
          <div class="second">
            <div class="div-icon">
              <div class="div-circle circle-wait">
                <p>진행</p>
              </div>
              <div class="div-circle circle-proceeding">
                <div>
                  <p>미션</p>
                  <p>시도</p>
                </div>
              </div>
              <div class="div-circle circle-succeeded">
                <p>성공</p>
              </div>
            </div>

            <map-stage-template
                            v-for="(category, ci) in title"
                            :key="category"
                            @showModal="showModal"
                            @openCertification="openCertification"
                            is-coding-party
                            :title="category"
                            :desc="desc[ci]"
                            :missions="missions[ci]"
                            is-trial></map-stage-template>

            <img class="complete" :src="medal[complete ? 'complete' : 'gray']" @click="showCompleteCert">
          </div>
        </div>
      </template>
      <template v-else>
        <img @click="showModal('map-alert-template', '본 서비스는 PC / 태블릿에서<br/>사용 가능합니다.')" src="../assets/images/map/mobile_bg_cp.jpg">
      </template>
    </div>

    <!-- 코딩파티 최초참가시 사용자정보 입력팝업창 -->
    <map-info-input-template
      v-if="isNonUserInfo"
      @saveUser="saveUser"
      :userDevice="userDevice"
      :courseCat="courseCat"
      is-trial
    />
    <!-- 공통모달창 -->
    <component v-if="isShowModal" :is="modal" :data="modalData" @close="isShowModal = false" :userDevice="userDevice" :confirm="confirm"></component>
  </div>
</template>


<script>

  import axios from 'axios'
  import mobileDetect from 'mobile-detect'

  // 학습관련
  import mapStageTemplate from './map/MapPartialStage'
  import certificateTemplate from './map/MapPartialCertificate'
  import mapHeaderTemplate from './map/MapPartialHeader'
  import mapInfoInputTemplate from './map/MapInfoInputPopup'
  import mapAlertTemplate from './map/MapAlert'

  import { title, desc } from '../data.json'

  export default {
    name: "CodingNonLogin",
    components: {
      mapStageTemplate,
      certificateTemplate,
      mapHeaderTemplate,
      mapInfoInputTemplate,
      mapAlertTemplate
    },
    data() {
      return {
        title,
        desc,
        missions: (() => {
          const arr1 = []
          for (let i = 1; i <= 4; i++) {
            const arr2 = [];
            for (let z = 1; z <= 10; z++) {
              arr2.push([`ESOF01_1_${i}_${z}`, 0]);
            }
            arr1.push(arr2);
          }
          return arr1;
        })(),
        isShowModal: false,
        modal: '',
        modalData: null,
        isNonUserInfo: false,
        isLoading: false,
        userDevice: 'pc',
        courseCat: 'ESOF01',
        confirm: '',
        medal: {
          complete: require('../assets/images/map/medal_complete.png'),
          gray: require('../assets/images/map/medal_complete_gray.png')
        }
      }
    },
    computed: {
      complete () {
        return !this.missions.flatMap(e => e).some(e => e[1] !== 2)
      }
    },
    created() {

      // 사용자 접속기기 체크
      const MD = new mobileDetect(window.navigator.userAgent);
      if (MD.tablet() !== null) this.userDevice = 'tablet';
      else if (MD.mobile() !== null) this.userDevice = 'mobile'
    },
    async mounted () {
      const userInfo = JSON.parse(this.getCookie('dduNonLoginUserInfo') || '{}');
      const lbcookie = userInfo.lbparty;

      // 코딩파티 기사용자
      if (lbcookie) {
        this.isLoading = false
        axios.get(
          `${this.API_SERVER_URL}/manage/codmos/record/party/ESOF01/1/0/0?${this.randomId()}`,
          {
            headers: { lbcookie }
          })
          .then(res => {
            if (res.data.code !== '1000' || !Array.isArray(res.data.docs)) return
            res.data.docs.forEach(e => {
              const IS_CLEARED = e.isCleared ? 2 : 1
              if (IS_CLEARED > this.missions[e.stageCat - 1][e.missionCat - 1][1])
                this.$set(this.missions[e.stageCat - 1][e.missionCat - 1], 1, IS_CLEARED)
            })
          })
          .finally(() => {
            this.isLoading = true
          })
      }
      // 코딩파티 최초 참가자
      else {
        //console.log(`[LBCookie] Not Exist!`);
        this.isNonUserInfo = true
      }

      // 코딩파티 진행시 하단 구문 활성화
      return;

      // 코딩파티 종료시 하단 구문 활성화
      // this.showModal('map-alert-template', '2018 온라인 코딩파티 시즌 2가 종료되었습니다.<br>' +
      //   '많은 성원에 힘입어 스테이지에<br>' +
      //   '총 <font color="#000" style="font-weight: 700;">511,673</font>번 참여했습니다.<br>' +
      //   '확인 버튼을 누르면 미션을 다시 해볼 수 있습니다.',
      //   () => {
      //     const COOKIE = this.getCookie()

      //     if (typeof COOKIE.lbparty !== 'undefined') {
      //       this.isLoading = false
      //       axios.get(
      //         `${this.API_SERVER_URL}/manage/codmos/record/party/ESOF01/1/0/0?${this.randomId()}`,
      //         {
      //           headers: {
      //             lbcookie: this.getCookie('lbparty')
      //           }
      //         })
      //         .then(res => {
      //           if (res.data.code !== '1000' || !Array.isArray(res.data.docs)) return
      //           res.data.docs.forEach(e => {
      //             const IS_CLEARED = e.isCleared ? 2 : 1
      //             if (IS_CLEARED > this.missions[e.stageCat - 1][e.missionCat - 1][1])
      //               this.missions[e.stageCat - 1][e.missionCat - 1][1] = IS_CLEARED
      //           })
      //         })
      //         .finally(() => {
      //           this.isLoading = true
      //         })
      //     }
      //     else {
      //       this.isNonUserInfo = true
      //     }
      //   });
    },
    methods: {
      showCompleteCert () {
        if (this.complete) {
          this.showCertPopup({ title: 'complete', isTrial: true });
        } else {
          this.showModal('map-alert-template', '미션을 완료 해주세요.')
        }
      },
      openCertification(data) {
        this.showCertPopup(data);
      },
      showCertPopup(data) {
        this.popupUri = new URL(`${location.origin}/codmos/certificate`);
        const popup = this.$refs.winPopup.openWinPop(this.popupUri, 1200, 750);
        popup.onload = () => {
          if (g_winPopup)  {
            this.$refs.winPopup.sendEvtToChild(data);
          }
        }
      },
      showModal(template, data, func) {
        this.confirm = func;
        this.modalData = data;
        this.modal = template;
        this.isShowModal = true;
      },
      saveUser(req) {
        this.isNonUserInfo = false;
        this.isLoading = true;
      },
    }
  }
</script>

<style>
  @import '../assets/styles/map/map_default.css';
</style>
<style lang="scss">
  @import '../assets/styles/map/map_tablet';
  @import '../assets/styles/map/map_mobile';
</style>
<style scoped>
  .complete {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/CodmosMapNonLogin.vue